interface AuthRequest {
  action: 'signIn' | 'signUp' | 'signOut' | 'verifyToken' | 'getUser' | 'checkAdminStatus' | 'inviteAdmin';
  email?: string;
  password?: string;
  token?: string;
  inviteEmail?: string;
  role?: string;
}

interface AuthResponse {
  success: boolean;
  data?: any;
  error?: string;
  user?: any;
  session?: any;
}

class AuthService {
  private apiUrl: string;

  constructor() {
    // Use the deployed API Gateway URL
    this.apiUrl = process.env.REACT_APP_API_URL || 'https://54v0v1tgji.execute-api.eu-west-2.amazonaws.com/prod';
  }

  private async makeRequest(requestData: AuthRequest): Promise<AuthResponse> {
    try {
      const response = await fetch(`${this.apiUrl}/auth`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Auth service error:', error);
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Network error'
      };
    }
  }

  async signIn(email: string, password: string): Promise<AuthResponse> {
    return this.makeRequest({
      action: 'signIn',
      email,
      password
    });
  }

  async signUp(email: string, password: string): Promise<AuthResponse> {
    return this.makeRequest({
      action: 'signUp',
      email,
      password
    });
  }

  async signOut(token: string): Promise<AuthResponse> {
    return this.makeRequest({
      action: 'signOut',
      token
    });
  }

  async verifyToken(token: string): Promise<AuthResponse> {
    return this.makeRequest({
      action: 'verifyToken',
      token
    });
  }

  async getUser(token: string): Promise<AuthResponse> {
    return this.makeRequest({
      action: 'getUser',
      token
    });
  }

  async checkAdminStatus(token: string): Promise<AuthResponse> {
    return this.makeRequest({
      action: 'checkAdminStatus',
      token
    });
  }

  async inviteAdmin(token: string, inviteEmail: string, role: string = 'admin'): Promise<AuthResponse> {
    return this.makeRequest({
      action: 'inviteAdmin',
      token,
      inviteEmail,
      role
    });
  }
}

export const authService = new AuthService();
export default authService;
